import banner from "../../assets/img/service-banner4.avif";
const data = [
  {
    title: "Bid Strategy & Value Positioning",
    description:
      "We help plan your bid approach, ensuring you clearly demonstrate added value and alignment with tender requirements.",
  },
  {
    title: "Bid Writing & Presentation",
    description:
      "From content development to formatting and proofreading, we ensure your tender documents are well-structured, persuasive, and professionally presented.",
  },
  {
    title: "Evaluation Insight",
    description:
      "We explain how tenders are assessed, helping you align your responses with scoring criteria and avoid common pitfalls.",
  },
  {
    title: "Site Visit Preparation",
    description:
      "We assist you in preparing for site visits, inspections, or demonstrations, ensuring your team is ready and confident.",
  },
  {
    title: "Presentation & Interview Coaching",
    description:
      "We offer proven techniques for delivering strong presentations and handling evaluation panel questions effectively.",
  },
  {
    title: "Interview Simulation & Feedback",
    description:
      "Gain insight from experienced supplier interviewers to better prepare for interviews and improve performance.",
  },
  {
    title: "Post-Tender Feedback Guidance",
    description:
      "We guide you in requesting and using feedback to improve future submissions and continuously raise your tendering standards.",
  },
  {
    title: "Flexible Support—Tailored to Your Needs",
    description:
      "Whether you need full bid management or support with specific sections, we’ll work closely with you to deliver results. Our goal is to ensure your hard work is not lost in a poorly presented submission—but instead becomes a winning tender that meets all technical and formal requirements.",
  },
];
const WinningContracts = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>Maximize Your Chances of Winning Contracts</h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={banner}
                alt="Maximize Your Chances of Winning Contracts"
                className="img-fluid"
                title="Maximize Your Chances of Winning Contracts"
              />
              <p>
                Navigating procurement and tender processes can be
                complex—especially for small and medium-sized enterprises. At
                GGAS Maintenance Tooling &amp; Equipments (GGAS), we offer
                expert support to help you compete more effectively and secure
                the contracts that matter most to your business.
              </p>
              <p>
                With our deep experience in managing procurement exercises, we
                understand what evaluators look for—and more importantly, how
                you can stand out.
              </p>
            </div>
            <div className="body">
              <h4>Our Warranty Contracts Services Include:</h4>
              <div className="row">
                {data.map((item, i) => {
                  return (
                    <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
                      <div className="serviceItemCard">
                        <h6>{item.title}</h6>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="footer">
              <p>
                Partner with GGAS to strengthen your competitive edge in
                procurement.
              </p>
              <p>
                Let us help you craft winning bids that open doors to
                new opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WinningContracts;
